import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { BATCH_IMAGES_TYPE } from '@utils/CONST'



const RefListModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: openClick,
    }));

    const { projectType } = props

    const [refListVisible, setRefListVisible] = useState(false);
    const [refList, setRefList] = useState([]);

    const openClick = (list) => {
        console.log(list)
        setRefList(list)
        setRefListVisible(true)
    }



    return <>
        <PSAIModal
            title={projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '全部辅品' : '全部详情页'}
            maxWidth={750}
            okText={'确定'}
            open={refListVisible}
            maskClosable={true}
            onCancel={() => setRefListVisible(false)}
            onOk={() => setRefListVisible(false)}
            cancelButtonProps={{ style: { display: 'none' } }}
            zIndex={1002}
        >
            <div className={`${styles.createTeamWrap} _beauty_scrollbar`}>
                {
                    refList?.map((item, index) => (
                        <div key={index} className={styles.refListItem}>
                            <img src={item?.url} alt="" />
                            {
                                projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && <p>数量{item?.num}</p>
                            }
                        </div>
                    ))
                }
            </div>
        </PSAIModal >
    </>
})
export default RefListModal
